import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import { Map } from 'immutable';
import styled from 'styled-components';
import { updateDimensions } from 'PreviewActions';
import { getSelectedAdstate } from 'Selectors';
import {
  FRAME,
  DEVICE,
  DIMENSIONS,
  CANVAS_SCALE,
  DEVICE_ORIENTATION,
} from 'PreviewConstants/';
import {
  HEIGHT,
  WIDTH,
  TOP,
  UI,
} from 'SharedConstants/';
import { Icon, LinkButton } from 'SharedComponents/';

const detailsPadding = 10;

const Details = styled.div`
  margin-top: ${props => (props.deviceFrameTop - detailsPadding) * -1}px;
  padding-bottom: ${props => props.deviceFrameTop + detailsPadding}px;
  display: flex;
  width: auto;
`;

const Name = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Size = styled.div`
  padding-left: 5px;
  white-space: nowrap;
`;

// temp. remove this once WveLinkButton is crossapp
const Button = styled(LinkButton)`
  font-size: 11.5px;
  line-height: 11.5px;
  height: 0;
  outline: none;
`;

const RightButton = styled(Button)`
  display: ${props => (
    props.hidden ? 'none' : 'block'
  )}
  margin-left: auto;
  margin-right: 30px;
`;

class ArtboardDetails extends PureComponent {
  resetSize = () => {
    const {
      // eslint-disable-next-line no-shadow
      updateDimensions,
      artboardViewport,
    } = this.props;

    updateDimensions(artboardViewport);
  };
  render() {
    const {
      props: {
        artboardViewport,
        artboardName,
        canvasScale,
        deviceOrientation,
        dimensions,
        adLoaded,
        reloadAd,
        device,
      },
      resetSize,
    } = this;

    const dimensionsWidth = dimensions.get(WIDTH);
    const dimensionsHeight = dimensions.get(HEIGHT);
    const width = `${dimensionsWidth * canvasScale}px`;
    const deviceFrameTop = device ? device.getIn([deviceOrientation, FRAME, TOP]) * canvasScale : 0;

    return (
      <Details
        deviceFrameTop={deviceFrameTop}
      >
        <Name>
          {artboardName}
        </Name>
        <Size>
          {`• ${dimensionsWidth.toFixed()}x${dimensionsHeight.toFixed()}`}
        </Size>
        { !isEqual(artboardViewport, dimensions) && !device &&
          <Button
            handleClick={resetSize}
          >
            Reset size
          </Button>
        }
        <RightButton
          hidden={!adLoaded}
          handleClick={reloadAd}
        >
          <Icon
            type="reload"
            appearance="primary"
          />
        </RightButton>
      </Details>
    );
  }
}

ArtboardDetails.propTypes = {
  artboardName: PropTypes.string.isRequired,
  dimensions: PropTypes.instanceOf(Map).isRequired,
  artboardViewport: PropTypes.instanceOf(Map).isRequired,
  updateDimensions: PropTypes.func.isRequired,
  canvasScale: PropTypes.number.isRequired,
  reloadAd: PropTypes.func.isRequired,
  adLoaded: PropTypes.bool.isRequired,
  deviceOrientation: PropTypes.string.isRequired,
  device: PropTypes.instanceOf(Map),
};

ArtboardDetails.defaultProps = {
  device: null,
};

const mapStateToProps = (state) => {
  const adState = getSelectedAdstate(state);
  return {
    dimensions: state.getIn([UI, DIMENSIONS]),
    artboardName: adState.name,
    artboardViewport: adState.viewport,
    canvasScale: state.getIn([UI, CANVAS_SCALE]),
    device: state.getIn([UI, DEVICE]),
    deviceOrientation: state.getIn([UI, DEVICE_ORIENTATION]),
  };
};

const mapDispatchToProps = dispatch => ({
  updateDimensions: dimensions =>
    dispatch(updateDimensions(dimensions)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ArtboardDetails);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/ResizableContainer/ArtboardDetails.jsx